import {GatsbyBrowser} from 'gatsby'

import {detectPageTranslation} from '@helios/shared/utils/detect-page-transltion'

export const onInitialClientRender: GatsbyBrowser['onInitialClientRender'] = () => {
    detectPageTranslation()
}
